import React, { ReactElement } from 'react'
import { IRadioInput } from '../../interfaces/FormFields'

const RadioButton = ({
  id,
  name,
  label,
  value,
  register,
  checked,
  labelClassName = '',
  error,
  disabled,
  onChange,
}: IRadioInput): ReactElement => {
  return (
    <label
      className={`inputRadioWrapper ${labelClassName}`}
      htmlFor={id + value}
    >
      <input
        id={id + value}
        name={name}
        type="radio"
        value={value}
        className="inputRadio"
        defaultChecked={checked}
        ref={register}
        disabled={disabled}
        onChange={onChange}
      />
      <div className={`inputRadioMask ${error ? 'errorHighlight' : ''}`} />
      <span className="inputRadioLabel">{label}</span>
    </label>
  )
}

export default RadioButton
